import { render, staticRenderFns } from "./choujiang.vue?vue&type=template&id=12e04492&"
import script from "./choujiang.vue?vue&type=script&lang=js&"
export * from "./choujiang.vue?vue&type=script&lang=js&"
import style0 from "./choujiang.vue?vue&type=style&index=0&id=12e04492&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.0_rm23m4wqnartkrat7nvkqiuwja/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports